import { getPageType } from '~/events/utils/pageType'
import productTransformer from './transformers/product.transformer'

export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.CHECKOUT.STEP_LOAD, ({ cartState }) => {
    // Ensure this event is triggered only on the "view_cart" step (checkout step 0)
    if (0 !== cartState.checkout.currentStep) {
      return
    }

    if (!cartState || !cartState.cartData || !cartState.cartData.items) {
      return
    }

    const transformedItems = cartState.cartData.items
      .filter(item => item.shoppable && item.product)
      .map((item, i) =>
        productTransformer(
          item.product,
          item.amount,
          item.prices.unitWithoutTax,
          item.prices.unitWithTax,
          i,
          null,
          item.attributes?.custom?.colour ?? null,
          item.attributes?.custom?.master_item_id ?? null,
        ),
      )

    if (transformedItems.length === 0) {
      return
    }

    // Calculate cart totals
    const totalValue = transformedItems.reduce((sum, item) => sum + item.price * item.quantity, 0)
    const totalValueVat = transformedItems.reduce((sum, item) => sum + item.price_vat * item.quantity, 0)
    const mktValAll = transformedItems.reduce((sum, item) => sum + item.price * item.quantity, 0)

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        currency: cartState.cartData.currencyCode,
        value: totalValue,
        value_vat: totalValueVat,
        coupon: '',
        mkt_val_all: mktValAll,
        items: transformedItems,
        google_tag_params: {
          ecomm_pagetype: getPageType(),
          ecomm_prodid: transformedItems.map(item => String(item.item_id)),
          ecomm_totalvalue: totalValue,
          ecomm_totalvalue_all: transformedItems.map(item => item.price * item.quantity),
        },
      },
    })
  })
}
